import { Deserializable } from '../../protocols/deserializable';
import { StatusPill } from '../../shared/status-pill';
import { DeathRecordSettlementStatusIdEnum } from '../../enum/shared/death-record-settlement-status-id.enum';
import { DeathRecordSettlementAmountTypeIdEnum } from '../../enum/shared/death-record-settlement-amount-type-id.enum';
import { DeathRecordPayeeTypeIdEnum } from '../../enum/shared/death-record-payee-type-id.enum';
import { DeathRecordSettlementTypeIdEnum } from '../../enum/shared/death-record-settlement-type-id.enum';
import { DeathRecordSpousalRolloverMethodIdEnum } from '../../enum/shared/death-record-spousal-rollover-method-id.enum';
import {
  RemittanceStatusPrimaryColorEnum,
  RemittanceStatusSecondaryColorEnum
} from '../../enum/shared/remittance-status-colors.enum';

const SETTLEMENT_STATUS_PILLS: Record<
  DeathRecordSettlementStatusIdEnum,
  [string, keyof typeof RemittanceStatusPrimaryColorEnum]
> = {
  [DeathRecordSettlementStatusIdEnum.Pending]: [$localize`Pending`, 'Pending'],
  [DeathRecordSettlementStatusIdEnum.Linked]: [$localize`Linked`, 'Submitted'],
  [DeathRecordSettlementStatusIdEnum.InFlight]: [$localize`In Flight`, 'Submitted'],
  [DeathRecordSettlementStatusIdEnum.Paid]: [$localize`Paid`, 'Approved'],
  [DeathRecordSettlementStatusIdEnum.Transferred]: [$localize`Transferred`, 'Approved'],
  [DeathRecordSettlementStatusIdEnum.Recovered]: [$localize`Recovered`, 'Approved'],
  [DeathRecordSettlementStatusIdEnum.Resolved]: [$localize`Resolved`, 'Approved']
};

export class MemberDeathRecordSettlement implements Deserializable {
  public id!: number;
  public deathRecordAccountId!: number;
  public settlementTypeId!: DeathRecordSettlementTypeIdEnum;
  public spousalRolloverMethodId: DeathRecordSpousalRolloverMethodIdEnum | null = null;
  public receivingInstitutionName: string | null = null;
  public payeeTypeId!: DeathRecordPayeeTypeIdEnum;
  public payeeFirstName: string | null = null;
  public payeeLastName: string | null = null;
  public amountTypeId: DeathRecordSettlementAmountTypeIdEnum | null = null;
  public amount: number | null = null;
  public percentage: number | null = null;
  public statusId!: DeathRecordSettlementStatusIdEnum;
  public isReleased!: boolean;
  public canEdit!: boolean;
  public canRemove!: boolean;
  public canRelease!: boolean;

  public payeeName!: string;
  public statusPill!: StatusPill;
  public isReleaseLockedByPayment!: boolean;

  public onDeserialize(): void {
    this.isReleaseLockedByPayment = this.isReleased && this.statusId !== DeathRecordSettlementStatusIdEnum.Pending;
    this.payeeName =
      this.payeeTypeId === DeathRecordPayeeTypeIdEnum.Estate
        ? $localize`Estate`
        : `${this.payeeFirstName ?? ''} ${this.payeeLastName ?? ''}`.trim();
    const [name, color] = SETTLEMENT_STATUS_PILLS[this.statusId];
    this.statusPill = new StatusPill(
      this.statusId,
      name,
      RemittanceStatusPrimaryColorEnum[color],
      RemittanceStatusSecondaryColorEnum[color]
    );
  }
}

export type MemberDeathRecordSettlementRequest = Pick<
  MemberDeathRecordSettlement,
  | 'settlementTypeId'
  | 'spousalRolloverMethodId'
  | 'receivingInstitutionName'
  | 'payeeTypeId'
  | 'payeeFirstName'
  | 'payeeLastName'
  | 'amountTypeId'
  | 'amount'
  | 'percentage'
>;
